import {
    useCallback,
    useEffect
} from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { setAppDynamicParams } from '../../../state/app.actions';
import portalCommunication from '../../mathletics-portal-communication-service';
import {
    handleSetCurrentClassGroup,
    handleError,
    handleNavigateToLandingRoute,
    handleModuleChange,
    handleMakeAPICall,
    parseMessage,
    handleLoaderSpinner,
    handleOpenDucsEventModal
} from './utils';

const {
    ERROR,
    SET_CURRENT_CLASS_GROUP,
    MODULE_CHANGE,
    MODULE_CHANGE_REQUEST,
    NAVIGATE_TO_LANDING_REQUEST,
    LOADING_SPINNER_REQUEST,
    MAKE_API_CALL,
    DUCS_EVENT_MODAL,
    SET_DYNAMIC_PARAMS
} = portalCommunication.MESSAGES;

export const usePortalCommunicationService = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const handleMessage = useCallback((event: MessageEvent) => {
        try {
            const messageEvent = parseMessage(event);

            if (!messageEvent) return;

            const {
                type,
                params,
                message
            } = messageEvent;

            switch (type) {
            case ERROR: {
                handleError({ dispatch });
                break;
            }
            case SET_CURRENT_CLASS_GROUP: {
                handleSetCurrentClassGroup({
                    params,
                    dispatch
                });
                break;
            }
            case MODULE_CHANGE: {
                handleModuleChange({
                    moduleId: message,
                    history,
                    dispatch
                });
                break;
            }
            case MODULE_CHANGE_REQUEST: {
                handleModuleChange({
                    moduleId: message,
                    history,
                    dispatch,
                    params
                });
                break;
            }
            case NAVIGATE_TO_LANDING_REQUEST: {
                handleNavigateToLandingRoute({
                    history,
                    moduleId: message
                });
                break;
            }
            case LOADING_SPINNER_REQUEST: {
                handleLoaderSpinner({
                    dispatch,
                    message
                });
                break;
            }
            case MAKE_API_CALL: {
                handleMakeAPICall({
                    dispatch,
                    params
                });
                break;
            }
            case DUCS_EVENT_MODAL: {
                handleOpenDucsEventModal({
                    dispatch,
                    message
                });
                break;
            }
            case SET_DYNAMIC_PARAMS: {
                dispatch(setAppDynamicParams(message));
                break;
            }
            default:
                break;
            }
        } catch (error) {
            console.error(error);
        }
    }, [dispatch, history]);

    useEffect(() => {
        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [handleMessage]);
};
